var map = {
	"./22_mummy.mp3": "27c0",
	"./27_grandma.mp3": "1000",
	"./28_grandpa.mp3": "9687",
	"./M_Brilliant.mp3": "2b60",
	"./M_Excellent.mp3": "4e25",
	"./M_Fantastic.mp3": "1be1",
	"./M_Great.mp3": "cda5",
	"./M_Perfect.mp3": "999c",
	"./M_Think again.mp3": "0727",
	"./M_Try again.mp3": "22aa",
	"./M_Very good.mp3": "12c8",
	"./M_Well done.mp3": "a6c8",
	"./M_Work harder.mp3": "60a74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7325";